window.addEventListener("DOMContentLoaded", () => {
  //********************* To Show the Tooltips *********************//
  //***************************************************************************//
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
  );
  //********************* To Show the Tooltips *********************//
  //***************************************************************************//

  //********************* For Sticky Navbar *********************//
  //************************************************************//
  const navbar = document.getElementById("navbar");
  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) {
      navbar.classList.add("shrink");
    } else {
      navbar.classList.remove("shrink");
    }
  });
  //********************* For Sticky Navbar *********************//
  //************************************************************//

  //********************* To Toggle Detail-offcanvas forms *********************//
  //***************************************************************************//
  const showInquiryBtn = document.querySelectorAll(".toggle-form");
  const cancleInquiryBtn = document.querySelectorAll(".cancle-toggle-form");
  const showTestInquiryBtn = document.querySelectorAll(".toggle-test-inquiry");
  const cancleTestInquiryBtn = document.querySelectorAll(".cancle-test-form");
  const InquiryBlock = document.querySelectorAll(".inquiry_block");
  const testInquiryBlock = document.querySelectorAll(".test_drive_inquiry");
  const initialStack = document.querySelector(".initial-stack");

  function handleInquiryFormToggle(selector) {
    selector.forEach((block) => {
      if (block.classList.contains("d-none")) {
        block.classList.remove("d-none");
        initialStack.classList.add("d-none");
      }
    });
  }
  function removeInquiryFormToggle(selector) {
    selector.forEach((block) => {
      if (!block.classList.contains("d-none")) {
        block.classList.add("d-none");
        initialStack.classList.remove("d-none");
      }
    });
  }

  function handleTestFormToggle(selector) {
    selector.forEach((block) => {
      if (block.classList.contains("d-none")) {
        block.classList.remove("d-none");
        initialStack.classList.add("d-none");
      } else {
        block.classList.add("d-none");
        initialStack.classList.remove("d-none");
      }
    });
  }
  function removeTestFormToggle(selector) {
    selector.forEach((block) => {
      if (!block.classList.contains("d-none")) {
        block.classList.add("d-none");
        initialStack.classList.remove("d-none");
      }
    });
  }

  showInquiryBtn.forEach((btn) =>
    btn.addEventListener("click", () => handleInquiryFormToggle(InquiryBlock))
  );
  cancleInquiryBtn.forEach((btn) =>
    btn.addEventListener("click", () => removeInquiryFormToggle(InquiryBlock))
  );
  showTestInquiryBtn.forEach((btn) =>
    btn.addEventListener("click", () => handleTestFormToggle(testInquiryBlock))
  );
  cancleTestInquiryBtn.forEach((btn) =>
    btn.addEventListener("click", () => removeTestFormToggle(testInquiryBlock))
  );
  //********************* To Toggle Detail-offcanvas forms *********************//
  //***************************************************************************//

  //********************* To Show the Skeleton Cards *********************//
  //***************************************************************************//

  const skeletons = document.querySelectorAll(".skeleton-loader");
  const contents = document.querySelectorAll(".product_card");
  setTimeout(() => {
    skeletons.forEach((skeleton) => (skeleton.style.display = "none"));
    contents.forEach((content) => (content.style.display = "block"));
  }, 2000);

  //********************* To Show the Skeleton Cards *********************//
  //***************************************************************************//

  //********************* To Filter the adds based on checkbox *********************//
  //*******************************************************************************//
  const filterBtns = document.querySelectorAll(".filter-check");

  filterBtns.forEach((btn) =>
    btn.addEventListener("change", () => {
      // Setting skeleton initially
      skeletons.forEach((skeleton) => (skeleton.style.display = "block"));
      contents.forEach((content) => (content.style.display = "none"));

      // Function to show skeleton on every change
      const showSkeleton = () => {
        setTimeout(() => {
          skeletons.forEach((skeleton) => (skeleton.style.display = "none"));
          contents.forEach((content) => (content.style.display = "block"));
        }, 600);
      };

      const allRows = document.querySelectorAll(
        ".row_all, .row_kia, .row_puegeot"
      );

      allRows.forEach((row) => row.classList.add("d-none"));

      if (btn.value === "kia") {
        document.querySelector(".row_kia").classList.remove("d-none");
        showSkeleton();
      } else if (btn.value === "puegeot") {
        document.querySelector(".row_puegeot").classList.remove("d-none");
        showSkeleton();
      } else if (btn.value === "all") {
        document.querySelector(".row_all").classList.remove("d-none");
        showSkeleton();
      } else {
        allRows.forEach((row) => row.classList.remove("d-none"));
      }
    })
  );

  //********************* To Filter the adds based on checkbox *********************//
  //*******************************************************************************//

  const socialLinks = document.querySelectorAll(".socia_share a");

  // Iterate through each link and add event listener
  socialLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default action (navigation)

      const url = link.getAttribute("data-url"); // Get URL from data attribute

      // Copy URL to clipboard
      navigator.clipboard
        .writeText(url)
        .then(function () {
          // Create the toast notification
          const toast = document.createElement("div");
          toast.classList.add(
            "toast",
            "align-items-center",
            "text-bg-success",
            "my-2",
            "border-0"
          );
          toast.setAttribute("role", "alert");
          toast.setAttribute("aria-live", "assertive");
          toast.setAttribute("aria-atomic", "true");

          toast.innerHTML = `
                    <div class="d-flex">
                        <div class="toast-body text-white">
                            URL copied!
                        </div>
                        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                    </div>
                `;

          // Append the toast to the container
          document.getElementById("toast-container").appendChild(toast);

          // Show the toast
          const bootstrapToast = new bootstrap.Toast(toast, { delay: 3000 });
          bootstrapToast.show();

          // Remove toast after it's hidden
          toast.addEventListener("hidden.bs.toast", function () {
            toast.remove();
          });
        })
        .catch(function () {
          // Handle error in case copying fails (optional)
          console.error("Failed to copy the URL.");
        });
    });
  });

  //********************* To add sticky nav on details pages *********************//
  //*******************************************************************************//

  var header = document.querySelector("#header");
  var subHeader = document.querySelector(".snb_wrap"); // Select sub-header
  var lastScrollTop = 0;

  if(subHeader){
    window.addEventListener("scroll", function() {
      let st = window.scrollY || document.documentElement.scrollTop;

      if (st > lastScrollTop) {
          // Scrolling down
          header.classList.add("hide");
          if (subHeader) {
              subHeader.classList.add("hide");
              subHeader.classList.remove("top");
          }
      } else {
          // Scrolling up
          header.classList.remove("hide");
          if (subHeader) {
              subHeader.classList.remove("hide");
              subHeader.classList.add("top");
          }
      }

      if (st === 0) {
        subHeader.classList.remove("top");
      }

      lastScrollTop = Math.max(st, 0); // Prevent negative values
  });
  }

   const tabs = document.querySelectorAll(".blog-archive__filter");
            const items = document.querySelectorAll(".blog-item");
if(items){

  tabs.forEach(tab => {
      tab.addEventListener("click", function() {
          const filter = this.dataset.filter;

          // Active tab UI
          tabs.forEach(t => t.classList.remove("is-active"));
          this.classList.add("is-active");

          // Filter posts
          items.forEach(item => {
              const categories = item.dataset.category;

              if (filter === "all" || categories.includes(filter)) {
                  item.style.display = "block";
              } else {
                  item.style.display = "none";
              }
          });
      });
  });
}

});



  
